export default {
    warn(...args) {
        // eslint-disable-next-line no-console
        console.warn(...args);
    },

    error(...args) {
        // eslint-disable-next-line no-console
        console.error(...args);
    }
};
